package frontend.lib

import OrdersScreenUI
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import frontend.App
import frontend.models.User
import frontend.pages.*
import kotlinx.browser.window
import kotlinx.coroutines.InternalCoroutinesApi
import org.jetbrains.compose.web.dom.Text

class Route(
    val path: String,
    val title: String,
    val content: @Composable (app: App, user: User, params: MatchResult?) -> Unit
) {
    val pathRegex = """:\w+""".toRegex()
    val pathFixed = pathRegex.replace(path, "([-\\\\w]+)")
    val routeRegex = """^#?$pathFixed$""".toRegex()

    fun params(url: String): MatchResult? {
        return routeRegex.find(url)
    }

    fun matches(url: String): Boolean {
        return routeRegex.matches(url)
    }

    @Composable
    fun show(app: App, user: User) {
        content(app, user, params(window.location.hash))
    }
}

enum class Routes(val route: Route) {
    Market(Route("/market", "Market") { app, user, m -> MarketScreenUI(app, user) }),

    Orders(Route("/orders", "Orders") { app, user, m -> OrdersScreenUI(app, user) }),
    OrderDetails(Route("/orders/:id", "Order details") { app, user, m -> OrdersScreenUI(app, user, m) }),

    Wallet(Route("/wallet", "Wallet") { app, user, m -> WalletScreenUI(app, user) }),
    WalletAccount(Route("/wallet/:accountId", "Account") { app, user, m -> WalletScreenUI(app, user, m) }),

    InvoiceDetails(Route("/invoices/:id", "Invoice details") { app, user, m -> InvoicesScreenUI(app, user, m) }),
    InvoiceDetails2(Route("/invoices\\?iid=:id&l=:l", "Invoice details") { app, user, m -> InvoicesScreenUI(app, user, m) }),
    Invoices(Route("/invoices", "Invoices") { app, user, m -> InvoicesScreenUI(app, user) }),

    MintingItem(Route("/minting/:id", "Minting") { app, user, m -> MintingUI(app, user, m) }),
    Minting(Route("/minting", "Minting") { app, user, m -> MintingUI(app, user) }),

    Profile(Route("/profile", "Profile") { app, user, m -> ProfileUI(app, user) }),

    Default(Route("/?", "Market") { app, user, m -> MarketScreenUI(app, user) }),
}

class Router {
    var current by mutableStateOf(findRoute(window.location.hash))

    val routes = Routes.values()

    fun dispatch(path: String) {
        window.location.hash = "#$path"
//        current = findRoute(path)
    }

    fun setRoute() {
        current = findRoute(window.location.hash)
    }

    fun findRoute(path: String): Route {
//        println(routes.size)
        val route = Routes.values().find { it.route.matches(path) }

        return route?.route ?: Route("", "Not found", { app, user, m -> Text("Not found") })
    }
}